import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gameconfigfolder",
  "use": "icon-gameconfigfolder-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-gameconfigfolder\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M22.43,5.74a.87.87,0,0,0-.85-.87H12.31L10.19,2.73H2.35a.9.9,0,0,0-.88.88V20.68a.89.89,0,0,0,.88.87H21.58a.89.89,0,0,0,.89-.87Zm-1.82,14H3.3V4.56H9.51l2.07,2.06h9.14ZM19,13.3l-3,3-1.21-1.21,1.82-1.82-1.82-1.81,1.21-1.22Zm-11.28,0L9.5,15.12,8.29,16.33l-3-3,3-3L9.5,11.49Zm3.78,4.29H9.65L12.76,9h1.83Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol